//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'head-bar',
    methods: {
        onClickLeft: function () {
            this.$router.go(-1)
        },
        onClickRight() {
        },
    },
    data() {
        return {}
    },
    computed: {
        isEntry() {
            //有返回的页面
            const entryRoutes = [
                '/fullScreenChart',
                '/label/searchAdvance',
                '/label/minesearchAdvance',
                '/label/searchResult',
                '/label/empDetail',
                '/arrangeWork',
                '/wfmine/list',
            ];
            return entryRoutes.indexOf(this.$route.path) > -1
        },
        title() {
            var titles = [this.$route.meta.title, this.$route.query.title]
            return titles.filter(title => title).join(' - ')
        },
    },
}
